require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-90-bookmarks.json") })
        }
      }, "path---article-90-bookmarks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-90-bookmarks!./.cache/json/article-90-bookmarks.json
// module id = 577
// module chunks = 231608221292675